interface ViewSearchResultsParams {
  searchTerm: string;
  resultCount: number;
  popularTermShortcut: boolean;
}

interface ClickSearchResultsParams {
  searchTerm: string;
  highlightedResult: boolean;
}

/**
 * Tracks when a user views search results
 * @param searchTerm - The search term used (will be lowercased)
 * @param resultCount - The total number of search results
 * @param popularTermShortcut - Whether the search came from clicking a popular search term
 */
export const trackViewSearchResults = ({
  searchTerm,
  resultCount,
  popularTermShortcut,
}: ViewSearchResultsParams): void => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'view_search_results',
      search_term: searchTerm.toLowerCase(),
      result_count: resultCount,
      popular_term_shortcut: popularTermShortcut,
    });
  }
};

/**
 * Tracks when a user clicks on a search result
 * @param searchTerm - The search term used (will be lowercased)
 * @param highlightedResult - Whether the clicked result is a SearchInformationBox (highlighted result)
 */
export const trackClickSearchResults = ({ searchTerm, highlightedResult }: ClickSearchResultsParams): void => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'click_search_results',
      search_term: searchTerm.toLowerCase(),
      highlighted_result: highlightedResult,
    });
  }
};
